export default __webpack_public_path__ + "static/media/afro_estetica.683159d1.jpg";